<template>
  <div class="card">
    <div class="h-title-con">
      <div class="h-title">
        <span class="title-text"><span class="title-tip"></span>权限管理</span>
      </div>
      <div class="h-button-warpper" v-if="!checkpage">
        <span class="orgBtn" @click=newAdd(permissionGroup)>保存</span>
        <span class="grayBtn" @click=back()>取消</span>
      </div>
      <div class="h-button-warpper" v-if="checkpage">
        <span class="orgBtn" @click=back()>返回</span>
      </div>
    </div>
    <div class="power">
      <label for="" class="yy-required">角色名称：</label>
      <el-input v-model="permissionGroup" placeholder="请输入角色名称" :disabled="checkpage"></el-input>
    </div>
    <el-tree
      :data="data"
      show-checkbox
      node-key="permission"
      ref="tree"
      highlight-current
      :props="defaultProps">
    </el-tree>
  </div>
</template>
<script>
import { getAuthorityData, AuthorityAdd, queryAuthority } from '@/api/report'
import commonMixin from '@/mixins/common.js'
export default {
  name: 'jurisdiction',
  data() {
    return {
      checkpage: false, // 是否是查看角色页面
      permissionGroup: '', // 权限组名称
      customerId: '',
      permissionList: [],
      data: [],
      defaultProps: {
        children: 'children',
        label: 'permissionName'
      }
    }
  },
  mixins: [commonMixin],
  created() {
    // 判断是否是查看按钮点击进入页面
    if (this.$route.query.method === 'detail') {
      this.checkpage = true
    }
    // 编辑按钮点击进入
    if (this.$route.query.id) {
      this.queryAuthorityList()
    }
    // 新增
    this.getAuthority()
  },
  methods: {
    // 递归
    recursionFn(data) {
      data.forEach((item, index) => {
        if (item.children.length > 0) {
          item.disabled = true
          this.recursionFn(item.children)
        } else {
          data[index].disabled = true
        }
      })
    },
    // 请求权限组数据---权限管理新增进入页面请求
    getAuthority() {
      getAuthorityData('/permission/list', 'get')
        .then(res => {
          // console.log(res)
          if (res.code === 0) {
            this.data = res.data
            if (this.checkpage) {
              this.recursionFn(this.data)
            }
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(errData => {
          this.$message.error('error 出错了')
          console.log(errData)
        })
    },
    // 点击编辑查询以保存的权限列表
    queryAuthorityList() {
      this.permissionList = []
      queryAuthority('/role/get/' + this.$route.query.id, 'get')
        .then(res => {
          // console.log(res)
          if (res.code === 0) {
            console.log(res.data.permissions)
            for (let i = 0, len = res.data.permissions.length; i < len; i++) {
              this.permissionList.push(res.data.permissions[i].permission)
            }
            this.permissionGroup = res.data.roleName
            this.$refs.tree.setCheckedKeys(this.permissionList)
            console.log(this.permissionList)
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(errData => {
          this.$message.error('error 出错了')
          console.log(errData)
        })
    },
    // 新增保存接口
    newAdd() {
      const permissionsArr = this.$refs.tree.getCheckedNodes().concat(this.$refs.tree.getHalfCheckedNodes())
      if (!this.permissionGroup) {
        this.$message('请填写角色名称')
        return false
      }
      if (!permissionsArr.length) {
        this.$message('请选择对应权限')
        return false
      }
      const params = {
        permissions: permissionsArr,
        roleName: this.permissionGroup
      }
      var url = '/role/add'
      if (this.$route.query.id) {
        params.id = this.$route.query.id
        url = '/role/edit'
      }
      AuthorityAdd(url, 'post', params)
        .then(res => {
          // console.log(res)
          if (res.code === 0) {
            this.$message({
              message: '保存成功',
              type: 'success'
            })
            const path = '/config/%2Ftemplate%2Fmodule%2Fsystem%2Fsystem_role_list.json'
            this.goBack(path)
            this.$nextTick(() => {
              this.$bus.$emit('refresh-grid')
            })
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(errData => {
          this.$message.error('error 出错了')
          console.log(errData)
        })
    },
    getCheckedNodes() {
      console.log(this.$refs.tree.store._getAllNodes())
    },
    // 点击取消返回权限管理列表
    back() {
      const path = '/config/%2Ftemplate%2Fmodule%2Fsystem%2Fsystem_role_list.json'
      this.goBack(path)
    }
  }
}
</script>
<style type="text/scss" lang="scss" scoped>
.power {
  padding: 15px 20px;
  box-sizing: border-box;
  font-size: 14px!important;
  label {
    font-weight: 400;
  }
  .el-input {
    width: 178px;
  }
}

.el-tree {
  box-sizing: border-box;
  min-height: 540px;
  overflow-y: scroll;
  margin: 0 20px 20px;
  border-radius: 6px;
  padding:20px;
  padding-left:90px;
  flex: 1;
}

</style>



// WEBPACK FOOTER //
// src/_app/wwka/src/views/jurisdiction/index.vue